import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useCommonStyles = makeStyles({
  inputFieldLabel: {
    fontWeight: 600,
  },
  inputField: {
    minWidth: '80px',
    border: '1px solid #616161',
    ':hover': {
      ...shorthands.borderColor('#000000'),
    },
    ':focus-within': {
      ...shorthands.borderColor('#000000'),
    },
  },
  modalSurface: {
    borderRadius: 0,
  },
  modalBody: {
    gap: '14px',
  },
  tooltip: {
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralForegroundInverted,
  },
  inputCharCounterHint: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  buttonAsLink: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    ':hover': { textDecoration: 'none' },
    ':focus': { textDecoration: 'none' },
    ':focus-visible': { outlineStyle: 'solid', },
    ':active': { textDecoration: 'none' },
  },
  richTextContent: {
    '& ul, & ol': {
      paddingInlineStart: '40px',
    },
    '& ul': {
      listStyleType: 'disc',
    },
    '& ul ul': {
      listStyleType: 'circle',
    },
    '& ul ul ul': {
      listStyleType: 'square',
    },
    '& ol': {
      listStyleType: 'decimal',
    },
  },
});
